<!-- src/components/filters/TexturesCTFilter.vue -->
<template>
  <ListFilter field="textures_ct" :options="opts" label="Текстуры по КТ" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/>
</template>

<script>
import ListFilter from './ListFilter.vue'
export default {
  name: 'TexturesCTFilter',
  components: { ListFilter },
  data() {
    return {
      opts: ['волнисто-линзовидная','линзовидная','линзовидно-волнистая','линзовидно-волнистая биотурбированная','линзовидно-слоистая','массивная','массивная биотурбированная','неясно пятнисто-слоистая','неясно слоистая','неясно-пятнистая','параллельная с выклиниванием, линзовидная','параллельно слоистая','пятнистая','пятнисто-массивная','пятнисто-слоистая','рябь','слоистая','тонко слоистая','узловато-слоистая']
    }
  }
}
</script>
